import { render, staticRenderFns } from "./TaskRunParametersTable.vue?vue&type=template&id=36a08894"
import script from "./TaskRunParametersTable.vue?vue&type=script&lang=js"
export * from "./TaskRunParametersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports